import { Component, OnDestroy, OnInit, ElementRef, ViewChild, Renderer2, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { FileService } from '../../../core/service/file.service';
import { Subscription } from 'rxjs';
import { BuildingDocumentType, BuildingDocumentTypeToString } from '../../model/const/documentEnums';
import { SelectionItem } from '../../../core/component/select/select.component';
import { BuildingDocumentService } from '../../service/data/building-document.service';
import { Building } from '../../model/building';
import { BuildingDocument } from '../../model/building-document';

@Component({
    selector: 'app-building-document-form',
    templateUrl: './building-document-form.component.html',
    styleUrls: ['./building-document-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BuildingDocumentFormComponent implements OnDestroy, OnInit {
  constructor(
    private _actionService: ActionWindowService,
    private _dataService: BuildingDocumentService,
    private _fb: FormBuilder,
    private _fcf: FormControlExFactory,
    private _renderer: Renderer2
  ) {}

  private _subscription: Subscription = new Subscription();
  dataContext: Building;
  form: FormGroup;

  connectionTypes: SelectionItem[];

  cancel() {
    this._actionService.close();
  }

  ngOnDestroy() {
    this._subscription.unsubscribe();
    this._subscription = null;
  }

  ngOnInit() {
    this.connectionTypes = [
      BuildingDocumentType.General,
      BuildingDocumentType.Drawing,
      BuildingDocumentType.ExteriorPhoto,
      BuildingDocumentType.CommonAreasPhoto,
      BuildingDocumentType.SalesDocument,
    ].map(t => new SelectionItem(BuildingDocumentTypeToString(t), t));

    this.form = this._fb.group({
      caption: this._fcf.createMandatory('LEASE_AGREEMENT_DOCUMENT.CAPTION', ''),
      connectionType: this._fcf.createMandatory('DOCUMENT.DOCUMENT_TYPE', BuildingDocumentType.General),
      document: this._fcf.createMandatory('', null),
      building: this._fcf.createHidden(this.dataContext.id),
    });
  }

  onFileChange(files: FileList) {
    if (files && files.length === 1) {
      this.form.controls['document'].setValue(files[0]);
      this.form.controls['caption'].setValue(files[0].name.substr(0, files[0].name.lastIndexOf('.')));
    } else {
      this.form.controls['caption'].reset();
    }
  }

  onSubmit() {
    if (this.form.valid) {
      this._subscription.add(
        this._dataService.add(Object.assign(new BuildingDocument(), this.form.value)).subscribe(() => this._actionService.complete(true))
      );
    }
  }
}
